import styled from 'styled-components';
import { breakpoints } from '../../constants';
import { IOption } from '../../types';
import { createMarkup } from '../../utils';
import { Button } from '../Button';
import { StepContainer } from '../StepContainer';

const ButtonContainer = styled.div``;

interface IProps {
    className?: string;
    options: IOption[];
    title: string;
    onStepButtonClick(option: IOption): void;
}

const BaseAnswerSelector = ({
    className,
    options,
    title,
    onStepButtonClick,
}: IProps) => (
    <StepContainer className={className}>
        <h3 dangerouslySetInnerHTML={createMarkup(title)} />
        <ButtonContainer>
            {options.map((option) => (
                <Button
                    key={option.title}
                    onClick={() => onStepButtonClick(option)}
                >
                    {option.title}
                </Button>
            ))}
        </ButtonContainer>
    </StepContainer>
);

export const AnswerSelector = styled(BaseAnswerSelector)`
    h3 {
        margin-bottom: 24px;
    }

    ${ButtonContainer} {
        display: flex;

        @media (${breakpoints.mediumMin}) {
            display: inline-flex;
        }
    }

    ${Button}:first-of-type {
        margin-right: 16px;
    }
`;
